import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlusCircle, FiLink, FiCopy } = FiIcons;

const steps = [
  {
    icon: FiPlusCircle,
    color: 'bg-blue-100 text-blue-600',
    title: 'Create a Room',
    desc: 'Generate a secure, temporary room with a single click. No personal info required.'
  },
  {
    icon: FiLink,
    color: 'bg-indigo-100 text-indigo-600',
    title: 'Share the Key',
    desc: 'Give the room name and password to your other devices or coworkers.'
  },
  {
    icon: FiCopy,
    color: 'bg-purple-100 text-purple-600',
    title: 'Sync Effortlessly',
    desc: 'Paste text or drop files. They appear instantly on all connected devices.'
  }
];

export default function HowItWorks() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4">Sharing made simple.</h2>
          <p className="text-gray-500 font-medium">Three steps to universal clipboard access.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          {steps.map((step, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.2 }}
              className="relative text-center group"
            >
              {idx < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-1/2 w-full h-[2px] bg-gray-50 -z-10" />
              )}
              <div className={`w-24 h-24 ${step.color} rounded-3xl flex items-center justify-center mx-auto mb-8 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                <SafeIcon icon={step.icon} className="w-10 h-10" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-4">{step.title}</h3>
              <p className="text-gray-600 font-medium leading-relaxed">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}